import React, { useContext } from 'react'
import './index.sass'
import { DarkModeContext } from '../../global/Theme'
import {useHistory} from 'react-router'
import { ButtonSmall, ButtonWhite } from '../common/Button'

import { LazyLoadImage } from 'react-lazy-load-image-component';


export default function UserWidget({id, name, username, image, followers, price, thumb}) {
    const { isDark } = useContext(DarkModeContext);
    const history = useHistory()
    const gotoProfile = () => {
        history.push({
            pathname: `/user/${username}`
        })    
    }

    return (
        <div className="search-user-widget" onClick={gotoProfile}>
            <div className="search-user-col-left">
            <LazyLoadImage alt={image.alt}
                    placeholderSrc={thumb}
                    effect="blur"
                    threshold={100}
                    height={image.height}
                    src={image}
                    width={image.width} />
                <div className="search-user-data">
                    <div className="search-user-content">
                        <h1 className={`${isDark ? 'h1-dark' : 'h1-light'}`}>{username}</h1>
                        <p>{name}</p>
                        </div>
                    <div className="search-user-followers-count">
                        <p>{followers != null ? followers : 0} Lovrs</p>
                            
                    </div>
                </div>
            </div>
            <div className="search-user-col-right">
                <div className="search-user-cta-1">
                    <ButtonWhite text={price == null || price == 0 || price == 'Free' ? 'Free' : `$${price}/month`} />
                </div>
            </div>
        </div>
    )
}
